export default __webpack_public_path__ + "static/media/section2-bg.d5a242dc.webp";